var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 26",
    width: 21,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#a32fa3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m20 10.5c0 7.4-9.5 13.7-9.5 13.7 0 0-9.5-6.3-9.5-13.7 0-2.5 1-4.9 2.8-6.7 1.8-1.8 4.2-2.8 6.7-2.8 2.5 0 4.9 1 6.7 2.8 1.8 1.8 2.8 4.2 2.8 6.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m13.6 10.5c0 1.3-0.7 2.4-1.9 2.9-1.2 0.5-2.6 0.2-3.5-0.7-0.9-0.9-1.1-2.2-0.6-3.4 0.4-1.2 1.6-2 2.9-2q0.6 0 1.2 0.3 0.6 0.2 1 0.6 0.5 0.5 0.7 1.1 0.2 0.5 0.2 1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.fd39fde5428ba37aa7595e5fd8d22161.svg";
export { ForwardRef as ReactComponent };